import { Box, GridItem } from '@capitalise/ui-design-system';
import EmpoweredGuy from 'assets/svgs/empowered-guy.svg';
import { use100vh } from 'react-div-100vh';

export interface WelcomeProps {
  isSm: boolean;
  title: string;
  lead: string;
  image: JSX.Element;
}

const Welcome = ({ isSm, title, lead, image }: WelcomeProps) => {
  const Image = image || EmpoweredGuy;
  const height = use100vh();

  return (
    <Box display="grid" gridTemplateColumns={{ _: '1fr', sm: '1fr 1fr' }} width="100%">
      <GridItem
        gridColumn={1}
        display="flex"
        alignItems="center"
        justifyContent="center"
        width="100%"
        backgroundColor="teal-50"
        px={{ _: 'xsmall', lg: '0' }}
      >
        <Image
          width={isSm ? (height > 700 ? '100%' : '70%') : '505px'}
          height={isSm ? (height > 700 ? '100%' : '70%') : '528px'}
        />
      </GridItem>
      <GridItem
        gridColumn={{ _: 1, sm: 2 }}
        display="flex"
        flexDirection="column"
        margin={{ sm: 'auto' }}
        justifyContent={{ sm: 'center' }}
        width={{ _: '100%', sm: '438px' }}
        py={{ _: 'xsmall', sm: '0' }}
        px={{ _: 'xsmall', lg: '0' }}
      >
        <Box
          typography="heading-32"
          color="grey-900"
          pb="3xsmall"
          dangerouslySetInnerHTML={{ __html: title }}
        />
        <Box typography="body-18" color="grey-700" dangerouslySetInnerHTML={{ __html: lead }} />
      </GridItem>
    </Box>
  );
};

export default Welcome;
